import { CreatePersonalChatSidebar } from "./CreatePersonalChatSidebar";

export default CreatePersonalChatSidebar;
